import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import "./InputHomeworkForm.module.scss";

import DropDown from "components/UI/DropDown/DropDown";
import Checkbox from "components/UI/Checkbox/Checkbox";
import Tip from "components/UI/Tip/Tip";
import Button from "components/UI/Button/Button";
import Subject from "components/UI/Subject/Subject";
import Select from "react-select";
import { colourStyles } from "utilities/colored-select-circle.js";

/**
 * Import actions
 */
import {
    homeworkDescription,
    homeworkNote,
    homeworkDate,
    homeworkSubject,
    homeworkType,
    homeworkMark,
    homeworkImage,
    homeworkReset,
    homeworkTimeslot,
    homeworkDirectlyCreateTask
} from "actions/new-homework";
import homeworkStore from "actions/homework/store";
import homeworkUpdate from "actions/homework/update";

import getScheduleByDay from "selectors/schedule/day";

/**
 * Import FontAwesome
 */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const mapStateToProps = (state, props) => {
    return {
        homework: state.new_homework,
        subjects: state.user_subject.entities,
        colors: state.color.entities,
        schedule: state.authentication.user.schedule,
        user: state.authentication.user,
        auth: state.authentication,
        events: state.event
    };
};

const mapDispatchToProps = {
    homeworkDescription,
    homeworkNote,
    homeworkDate,
    homeworkSubject,
    homeworkType,
    homeworkMark,
    homeworkImage,
    homeworkStore,
    homeworkUpdate,
    homeworkReset,
    homeworkDirectlyCreateTask
};

const customStyles = {
    control: styles => ({
        ...styles,
        fontSize: "12px"
    }),
    option: styles => ({
        ...styles,
        fontSize: "12px"
    })
};

const homeworkTypes = [
    {
        value: "make",
        label: "Maak (M)"
    },
    {
        value: "learn",
        label: "Leer (L)"
    },
    {
        value: "make_learn",
        label: "Maak en Leren (ML)"
    },
    {
        value: "read",
        label: "Lezen (LZ)"
    }
];

const valueFromId = (opts, id) => opts.find(o => o.value === id);
const valueFromLabel = (opts, label) => opts.find(o => o.label === label);
const valueFromValue = (opts, value) => opts.find(o => o.value === value);

class InputHomeworkForm extends Component {
    constructor() {
        super();

        this.state = {
            imagePreviewUrl: null
        };

        this.handleSubjectChange = this.handleSubjectChange.bind(this);
        this.handleTypeChange = this.handleTypeChange.bind(this);
        this.handleMarkChange = this.handleMarkChange.bind(this);
        this.onImageChange = this.onImageChange.bind(this);
        this.handleDescriptionUpdate = this.handleDescriptionUpdate.bind(this);
        this.handleNoteUpdate = this.handleNoteUpdate.bind(this);
        this.openImage = this.openImage.bind(this);
        this.deleteImage = this.deleteImage.bind(this);
        this.handleToggleDirectlyCreateTask = this.handleToggleDirectlyCreateTask.bind(
            this
        );
    }

    componentDidMount() {
        if (this.props.homework.image) {
            this.setState({
                imagePreviewUrl: this.props.homework.image
            });
        }
    }

    handleSubjectChange(event) {
        this.props.homeworkSubject(event.target.value);
    }

    handleDescriptionUpdate(event) {
        this.props.homeworkDescription(event.target.value);
    }

    handleNoteUpdate(event) {
        this.props.homeworkNote(event.target.value);
    }

    handleTypeChange(object) {
        this.props.homeworkType(object.value);
    }

    handleMarkChange() {
        this.props.homeworkMark(!this.props.homework.mark);
    }

    handleToggleDirectlyCreateTask() {
        this.props.homeworkDirectlyCreateTask(
            !this.props.homework.directlyCreateTask
        );
    }

    onImageChange(e) {
        const files = Array.from(e.target.files);
        if (files.length < 1) {
            return;
        }

        const image = files[0];
        let reader = new FileReader();

        reader.onloadend = () => {
            this.setState({
                imagePreviewUrl: reader.result
            });
            this.props.homeworkImage(image);
        };

        reader.readAsDataURL(image);
    }

    openImage(data) {
        var image = new Image();
        image.src = data;
        var w = window.open("");
        w.document.write(image.outerHTML);
    }

    deleteImage() {
        this.setState({
            imagePreviewUrl: null,
            image: null
        });

        this.props.homeworkImage(null);
    }

    render() {
        return (
            <div styleName="homework-form">
                <p>Soort*</p>
                <Select
                    onChange={this.handleTypeChange}
                    value={valueFromValue(
                        homeworkTypes,
                        this.props.homework.type
                    )}
                    options={homeworkTypes}
                    isSearchable={false}
                    styles={customStyles}
                    placeholder={"Selecteer soort"}
                    components={{
                        IndicatorSeparator: () => null
                    }}
                />
                <div styleName="tip-wrapper">
                    <p>Beschrijving (max 30 tekens)*</p>
                    <Tip
                        tip="Verzin afkortingen voor het huiswerk. Om het overzicht te bewaren en om ruimte te besparen en om snel je huiswerk in te kunnen voeren. Voorbeeld: ipv paragraaf schrijf je par. SO voor schriftelijke overhoring of H voor hoofdstuk, enz"
                        image="/images/tips/1.png"
                    />
                </div>

                <input
                    styleName="input description"
                    type="text"
                    value={this.props.homework.description}
                    onChange={this.handleDescriptionUpdate}
                    maxLength="30"
                    placeholder="Bijvoorbeeld par 1,2,3"
                />
                <div styleName="tip-wrapper">
                    <Checkbox
                        checked={this.props.homework.mark}
                        handleClick={this.handleMarkChange}
                        label="Markering"
                    />
                    <Tip
                        tip="Markeer huiswerk waar je een cijfer voor krijgt zodat ze extra opvallen! Vink de optie aan."
                        image="/images/tips/2.png"
                    />
                </div>
                {this.props.editing ? null : (
                    <div style={{ justifyContent: "left", display: "flex" }}>
                        <Checkbox
                            checked={this.props.homework.directlyCreateTask}
                            handleClick={this.handleToggleDirectlyCreateTask}
                            label="Maak direct 1 losse taak van huiswerkitem"
                        />
                    </div>
                )}

                <p>Notitie</p>
                <div styleName="note-background">
                    <textarea
                        styleName="note"
                        type="text"
                        placeholder="Notitie"
                        value={this.props.homework.note}
                        onChange={this.handleNoteUpdate}
                    />
                    <label htmlFor="single">
                        <FontAwesomeIcon
                            style={{
                                margin: "10px 10px 0 0",
                                cursor: "pointer"
                            }}
                            icon={["fas", "camera"]}
                        />
                    </label>
                    <input
                        type="file"
                        id="single"
                        onChange={this.onImageChange}
                    />
                </div>
                {this.state.imagePreviewUrl && (
                    <div styleName="image">
                        <FontAwesomeIcon
                            onClick={this.deleteImage}
                            styleName="delete"
                            icon={["far", "times"]}
                        />
                        <Button
                            title="bijlage bekijken"
                            normal
                            style={{
                                background: "#e5e5e5",
                                color: "#0088fe",
                                borderRadius: "3px",
                                height: "36px",
                                width: "224px"
                            }}
                            icon={["fal", "paperclip"]}
                            smallIcon
                            handleClick={() =>
                                this.openImage(this.state.imagePreviewUrl)
                            }
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InputHomeworkForm);
